import { Configuration as msalConfiguration } from "@azure/msal-browser";

const isProduction = import.meta.env.MODE === "production";

// Get some values from .env file
let {
  VITE_MSAL_REDIRECT_URL,
  VITE_MSAL_CLIENT_ID,
  VITE_MSAL_AUTHORITY,
} = import.meta.env;

// If development, use localhost
if (!isProduction) VITE_MSAL_REDIRECT_URL = "http://localhost:3004/home";

export const msal: msalConfiguration = {
  auth: {
    clientId: VITE_MSAL_CLIENT_ID ?? "",
    authority: VITE_MSAL_AUTHORITY,
    redirectUri: VITE_MSAL_REDIRECT_URL,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// S2 API config (pymble-apis)
export const api_s2 = {
  baseURL: isProduction
    ? "https://papi.pymblelc.nsw.edu.au/"
    : "http://localhost:8000/",
  scopes: ["api://pymble-apis/access"],
};

// My Pymble portal URL — used for "View live group" cross-links from admin detail pages
export const portalUrl =
  import.meta.env.VITE_PORTAL_URL ?? "https://my.pymblelc.nsw.edu.au";

// Co-curricular Presets admin surface (Phase 2 - Group D). Vite inlines the
// raw string value of `import.meta.env.*`, so compare to "true" explicitly -
// the literal string "false" would be truthy. Default OFF when unset so any
// new environment has to opt in. Local dev .env sets this to "true"; the
// Azure SWA workflow forces it to "false" until production launch sign-off.
export const PRESETS_ADMIN_ENABLED =
  import.meta.env.VITE_PRESETS_ADMIN_ENABLED === "true";
